import React, { Component } from 'react';
import { withRouter } from "react-router-dom";

import Firebase from 'firebase';



class step2 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            client: props.client,
            country: props.country
        }
    }


    componentWillUpdate(nextProps, nextState) {
        if (nextState.client !== this.state.client || nextState.country !== this.state.country) {
            this.props.setData(nextState.client, nextState.country);
        }

    }

    render() {
        return (
            <fieldset>
                <h2>Información de tu empresa</h2>
                <p className="text-muted">Solo unos datos generales de tu negocio</p>
                <br />
                <div className="form-group mb-3">
                    <input className="form-control" type="text" name="nombre_empresa" placeholder="Nombre empresa" value={this.state.client} onChange={(e) => { this.setState({ client: e.target.value }) }} />
                </div>
                <div className="form-group mb-3">
                    <input className="form-control" type="text" placeholder="Pais" value={this.state.country} onChange={(e) => { this.setState({ country: e.target.value }) }} />
                </div>
                <div className="row" style={{ position: "relative", bottom: "-219" }}>
                    <div className="col-6">
                        <button type="button" className="btn btn-primary" onClick={() => { this.props.callBack(1) }} >Atras</button>
                    </div>
                    <div className="col-6 text-right">
                        {
                            this.state.client && this.state.country ?
                                <button type="button" className="btn btn-primary" onClick={() => { this.props.callBack(3); }}>Siguiente</button>
                                :
                                <button type="button" className="btn btn-primary" disabled>Siguiente</button>
                        }
                    </div>
                </div>
            </fieldset>
        );
    }
}
export default step2;


// WEBPACK FOOTER //
// ./src/views/register/step2.js